export default __webpack_public_path__ + "static/media/news2.f2507040.jpg";